import React from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";

export const columns = [
  {
    dataField: "citizenId",
    text: "CT ID ",
    sort: false,
    headerStyle: { textAlign: "center" },
    style: { minWidth: "150px", textAlign: "center" },
  },
  {
    dataField: "type",
    text: "Type",
    sort: false,
    style: { minWidth: "120px", textAlign: "Left" },
  },
  {
    dataField: "registrationType",
    text: "Reg Type",
    sort: false,
    style: { minWidth: "100px", textAlign: "Left" },
  },

  {
    dataField: "registrationDate",
    text: "Date",
    sort: true,
    // headerStyle: { textAlign: "center" },
    style: { minWidth: "100px" },
    formatter: (cell, row) => {
      return moment((row && row.registrationDate) || null).format("DD-MM-YY");
    },
  },
  {
    dataField: "fullName",
    text: "Full Name",
    sort: false,
    style: { minWidth: "150px", textAlign: "Left" },
  },
  {
    dataField: "phoneNumber",
    text: "Mobile Number",
    sort: false,

    headerStyle: { textAlign: "center" },
    style: { minWidth: "150px", textAlign: "center" },
  },
  {
    dataField: "branchId",
    text: "Branch ID",
    headerStyle: { textAlign: "center" },
    sort: false,
    style: { minWidth: "150px", textAlign: "center" },
  },
  {
    dataField: "companyName",
    text: "Company Name",
    sort: false,
    style: { minWidth: "150px", textAlign: "left" },
  },

  {
    dataField: "emiratesId",
    text: "Emirates ID",
    headerStyle: { textAlign: "center" },
    sort: false,
    style: { minWidth: "150px", textAlign: "center" },
  },
  {
    dataField: "cardSerialNo",
    text: "Card Serial Number",
    sort: false,
    style: { minWidth: "150px", textAlign: "centers  p" },
  },
];
